<script setup lang="ts">
import { settings, people, home, enter } from "ionicons/icons";

import {
  IonContent,
  IonPage,
  IonTabButton,
  IonIcon,
  IonLabel,
  IonTabBar,
  IonTabs,
  IonRouterOutlet,
  onIonViewWillEnter,
  useIonRouter,
} from "@ionic/vue";
import { useRoute } from "vue-router";
import { useContextStore } from "@/stores/context";
import { useWindowWidth } from "@/composition/window";
import { reactive } from "vue";
import { useUserStore } from "@/stores/user";

const userStore = useUserStore();
const router = useIonRouter();

const { isMobile } = useWindowWidth();
const contextStore = useContextStore();
const route = useRoute();
const event_id = parseInt(route.params.event_id as string, 10);

onIonViewWillEnter(async () => {
  userStore.fetchRoles().then(() => {
    const myEvents = userStore.related.events.map((event) => event.id);
    if (myEvents.includes(event_id)) {
      contextStore.getEvent(event_id);
    } else {
      router.push("/home");
    }
  });
});

const state = reactive({
  modalSettings: false,
});
</script>
<template>
  <ion-page>
    <ion-content>
      <ion-tabs v-if="contextStore.event.id && isMobile">
        <ion-router-outlet></ion-router-outlet>
        <ion-tab-bar slot="bottom" style="padding-top: 1rem">
          <ion-tab-button tab="home" :href="`/event/${event_id}/home`">
            <ion-icon :icon="home" />
            <ion-label>Home</ion-label>
          </ion-tab-button>
          <ion-tab-button tab="visitors" :href="`/event/${event_id}/visitors`">
            <ion-icon :icon="people" />
            <ion-label>Visitors</ion-label>
          </ion-tab-button>
          <ion-tab-button tab="scan" :href="`/event/${event_id}/scan`">
            <ion-icon :icon="enter" />
            <ion-label>Check-in</ion-label>
          </ion-tab-button>


          <ion-tab-button
            tab="settings"
            @click="state.modalSettings = true"
            expand="block"
            :href="`/event/${event_id}/settings`"
          >
            <ion-icon :icon="settings" />
            <ion-label>Setup</ion-label>
          </ion-tab-button>
        </ion-tab-bar>
      </ion-tabs>
      <ion-router-outlet
        :animated="false"
        v-else-if="contextStore.event.id && !isMobile"
      ></ion-router-outlet>
      <p v-else class="ion-padding">Loading...</p>
    </ion-content>
  </ion-page>
</template>

<style lang="scss" scoped>
ion-chip {
  width: 100%;
}
.mngr_icon {
  margin-right: 10px;
}

ion-item.event_management {
  --inner-border-width: 0 0 0 0 !important;
}

ion-modal {
  --backdrop-opacity: var(--ion-backdrop-opacity, 3);
  --height: 680px;
}
</style>
